import { SxProps } from '@mui/material';

export const styledReceiptDetailsTitleWrapper: SxProps = {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
};

export const styledDetailsTitleWrapper: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const styledCrossedPrice: SxProps = {
  display: 'flex',
  gap: '5px',
};

export const styledCrossedPriceContent: SxProps = {
  textDecoration: 'line-through',
  opacity: '40%',
};
